import { render, staticRenderFns } from "./ProductBI.vue?vue&type=template&id=2bb00ed8&scoped=true"
import script from "./ProductBI.vue?vue&type=script&lang=js"
export * from "./ProductBI.vue?vue&type=script&lang=js"
import style0 from "./ProductBI.vue?vue&type=style&index=0&id=2bb00ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb00ed8",
  null
  
)

export default component.exports